<template>
  <div class="BuyerAccountParameterSettings">
    <div class="summary_bag">
      <div class="summary_complete_bag">
        <label class="title">买家账号各项参数设置及收费标准</label>
        <el-card class="card">
            <div slot="header">
                <span style="margin-right: 10px;">买家账号等级设置及收费标准</span>
                <el-button type="info" icon="el-icon-plus" @click="addList('1')"></el-button>
            </div>
            <div class="box" v-for="(item,index) in List" :key="index">
                <el-form 
                label-width="130px" 
                class="form" >
                    <el-row type="flex">
                        <el-form-item label="买家账号等级名称">
                            <el-input v-model="item.gradeName" :disabled="item.disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="item.charge" :disabled="item.disabled" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input> 元/条
                        </el-form-item>
                    </el-row>
                    <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="item.usageDescription" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="item.precautions" :disabled="item.disabled"></el-input>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="end">
                    <el-button v-if="item.cancel == 0" @click="cancel('1')">取消</el-button>
                    <el-button type="danger" @click="delSettings(item)" v-if="item.cancel != 0">删除</el-button>
                    <el-button type="primary" @click="edit(item)" v-if="item.btnText == 0">编辑</el-button>
                    <el-button type="primary" @click="save( item, '1' )" v-else-if="item.btnText == 1">保存设置</el-button>
                </el-row>
            </div>
        </el-card>
        <el-card class="card">
            <div slot="header">
                <span style="margin-right: 10px;">信用卡账号等级设置及收费标准</span>
                <el-button type="info" icon="el-icon-plus" @click="addList('2')"></el-button>
            </div>
            <div class="box" v-for="(item,index) in List2" :key="index">
                <el-form 
                label-width="130px" 
                class="form" >
                    <el-row type="flex">
                        <el-form-item label="信用卡等级名称">
                            <el-input v-model="item.gradeName" :disabled="item.disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="item.charge" :disabled="item.disabled" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input> 元/条
                        </el-form-item>
                    </el-row>
                    <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="item.usageDescription" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="item.precautions" :disabled="item.disabled"></el-input>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="end">
                    <el-button v-if="item.cancel == 0" @click="cancel('2')">取消</el-button>
                    <el-button type="danger" @click="delSettings(item)" v-if="item.cancel != 0">删除</el-button>
                    <el-button type="primary" @click="edit(item)" v-if="item.btnText == 0">编辑</el-button>
                    <el-button type="primary" @click="save( item, '2' )" v-else-if="item.btnText == 1">保存设置</el-button> 
                </el-row>
            </div>
        </el-card>
        <el-card class="card">
            <div slot="header">
                <span style="margin-right: 10px;">买家地址等级设置及收费标准</span>
                <el-button type="info" icon="el-icon-plus" @click="addList('3')"></el-button>
            </div>
            <div class="box" v-for="(item,index) in List3" :key="index">
                <el-form label-width="130px" class="form">
                    <el-row type="flex">
                        <el-form-item label="买家地址等级名称">
                            <el-input v-model="item.gradeName" :disabled="item.disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="item.charge" :disabled="item.disabled" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input> 元/条
                        </el-form-item>
                    </el-row>
                    <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="item.usageDescription" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="item.precautions" :disabled="item.disabled"></el-input>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="end">
                    <el-button v-if="item.cancel == 0" @click="cancel('3')">取消</el-button>
                    <el-button type="danger" @click="delSettings(item)" v-if="item.cancel != 0">删除</el-button>
                    <el-button type="primary" @click="edit( item)" v-if="item.btnText == 0">编辑</el-button>
                    <el-button type="primary" @click="save( item, '3' )" v-else-if="item.btnText == 1">保存设置</el-button> 
                </el-row>
            </div>
        </el-card>
        <el-card class="card">
            <div slot="header">
                <span style="margin-right: 10px;">下单IP地址等级设置及收费标准</span>
                <el-button type="info" icon="el-icon-plus" @click="addList('4')"></el-button>
            </div>
            <div class="box" v-for="(item,index) in List4" :key="index">
                <el-form label-width="130px" class="form">
                    <el-row type="flex">
                        <el-form-item label="下单IP地址等级名称">
                            <el-input v-model="item.gradeName" :disabled="item.disabled"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="item.charge" :disabled="item.disabled" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input> 元/条
                        </el-form-item>
                    </el-row>
                    <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="item.usageDescription" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="item.precautions" :disabled="item.disabled"></el-input>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="end">
                    <el-button v-if="item.cancel == 0" @click="cancel('4')">取消</el-button>
                    <el-button type="danger" @click="delSettings(item)" v-if="item.cancel != 0">删除</el-button>
                    <el-button type="primary" @click="edit(item)" v-if="item.btnText == 0">编辑</el-button>
                    <el-button type="primary" @click="save( item, '4' )" v-else-if="item.btnText == 1">保存设置</el-button> 
                </el-row>
            </div>
        </el-card>
        <el-card class="card">
            <div slot="header">
                <span style="margin-right: 10px;">买家账号组合方案</span>
                <el-button type="info" icon="el-icon-plus" @click="addList('5')"></el-button>
            </div>
            <div class="box" v-for="(item,index) in List5" :key="index">
                <el-form label-width="130px" class="form">
                    <label style="font-size:14px">方案{{index + 1}}：</label>
                    <el-form-item label="方案名称">
                        <el-input v-model="item.programName" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-row type="flex">
                        <el-form-item label="买家账号等级">
                            <el-select clearable v-model="item.buyerAccountRankId" placeholder="" :disabled="item.disabled">
                                <el-option
                                    v-for="(item, index) in List"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="信用卡账号等级">
                            <el-select clearable v-model="item.creditCardRankId" placeholder="" :disabled="item.disabled">
                                <el-option
                                    v-for="(item, index) in List2"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="买家地址等级">
                            <el-select clearable v-model="item.buyerAddressRankId" placeholder="" :disabled="item.disabled">
                                <el-option
                                    v-for="(item, index) in List3"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="下单IP等级">
                            <el-select clearable v-model="item.orderIPAddressRankId" placeholder="" :disabled="item.disabled">
                                <el-option
                                    v-for="(item, index) in List4"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <!-- <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="item.usageDescription" :disabled="item.disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="item.precautions" :disabled="item.disabled"></el-input>
                    </el-form-item> -->
                </el-form>
                <el-row type="flex" justify="end">
                    <el-button v-if="item.cancel == 0" @click="cancel('5')">取消</el-button>
                    <el-button type="danger" @click="delSettings1(item)" v-if="item.cancel != 0">删除</el-button>
                    <el-button type="primary" @click="edit1(item)" v-if="item.btnText == 0">编辑</el-button>
                    <el-button type="primary" @click="save1(item)" v-else-if="item.btnText == 1">保存设置</el-button> 
                </el-row>
            </div>
        </el-card>
        <el-dialog
            title="编辑"
            :visible.sync="dialogVisible"
            width="40%">
            <div>
                <el-form 
                label-width="130px" 
                class="form" >
                    <el-row type="flex">
                        <el-form-item label="买家账号等级名称">
                            <el-input v-model="gradeName"></el-input>
                        </el-form-item>
                        <el-form-item label="收费标准">
                            <el-input v-model="charge" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input> 元/条
                        </el-form-item>
                    </el-row>
                    <el-form-item label="用途说明">
                        <el-input type="textarea" v-model="usageDescription"></el-input>
                    </el-form-item>
                    <el-form-item label="注意事项">
                        <el-input type="textarea" v-model="precautions"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editDiallog()">保存设置</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="编辑"
            :visible.sync="dialogVisible1"
            width="40%">
            <div>
                <el-form 
                label-width="130px" 
                class="form" >
                    <el-form-item label="方案名称">
                        <el-input v-model="programName"></el-input>
                    </el-form-item>
                    <el-form-item label="买家账号等级">
                        <el-select v-model="buyerAccountRankId" placeholder="" clearable>
                            <el-option
                                v-for="(item, index) in List"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="信用卡账号等级">
                        <el-select v-model="creditCardRankId" placeholder="" clearable>
                            <el-option
                                v-for="(item, index) in List2"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="买家地址等级">
                        <el-select v-model="buyerAddressRankId" placeholder="" clearable>
                            <el-option
                                v-for="(item, index) in List3"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="下单IP等级">
                        <el-select v-model="orderIPAddressRankId" placeholder="" clearable>
                            <el-option
                                v-for="(item, index) in List4"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="dialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="editDiallog1()">保存设置</el-button>
            </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
  name: "BuyerAccountParameterSettings",
  data() {
    return {
        id: '',
        gradeName: '',
        charge: '',
        usageDescription: '',
        precautions: '',

        id1: '',
        programName: '',
        buyerAccountRankId: '',
        creditCardRankId: '',
        buyerAddressRankId: '',
        orderIPAddressRankId: '',

        dialogVisible: false,
        dialogVisible1: false,
        disabled: true,
        str: '',
        companyId: '',
        List: [{}],
        List2: [{}],
        List3: [{}],
        List4: [{}],
        List5: [{}]
    };
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.str.company_id
    this.selectSettings()
    this.selectSettings1()
  },
  methods: {
      edit(item) {
          this.dialogVisible = true
          this.id = item.id
          this.gradeName = item.gradeName
          this.charge = item.charge
          this.usageDescription = item.usageDescription
          this.precautions = item.precautions
      },
      editDiallog() {
            const API =  Baseurl + 'buyerAccountSettingController/updateBuyerAccountSetting'
            const paramsData = {
                id: this.id,
                gradeName: this.gradeName,                                  // 等级名称
                charge: this.charge,                                     // 收费标准
                usageDescription: this.usageDescription,                              // 用途说明
                precautions: this.precautions,                              // 注意事项
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.dialogVisible = false
                        this.selectSettings()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
      },
      save(item,type) {
          if(item.btnText === 1){
            if(type === '1' && item.gradeName == undefined){
                this.$message('买家账号等级名称不能为空')
                return
            }else if(type === '2' && item.gradeName === undefined){
                this.$message('信用卡账号等级名称不能为空')
                return
            }else if(type === '3' && item.gradeName === undefined){
                this.$message('买家地址等级名称不能为空')
                return
            }else if(type === '4' && item.gradeName === undefined){
                this.$message('下单IP地址等级名称不能为空')
                return
            }
            const API =  Baseurl + 'buyerAccountSettingController/insertBuyerAccountSetting'
            const paramsData = {
                gradeName: item.gradeName,                                  // 等级名称
                charge: item.charge,                                     // 收费标准
                usageDescription: item.usageDescription,                              // 用途说明
                precautions: item.precautions,                              // 注意事项
                type,                            // 类型
                companyId: this.companyId                                           // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        item.btnText = 0
                        this.selectSettings()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
          }else if(item.btnText === 0) {
              item.btnText = 1
          }
      },
      selectSettings() {
        const API =  Baseurl + 'buyerAccountSettingController/selectBuyerAccountSettings'
        const paramsData = {
            companyId: 1                                           // 公司id
        }
        ajaxPost(API,paramsData)
            .then((res) => {
                if( res.data.code === 200 ) {
                    this.List = res.data.data.buyerAccountSetting
                    this.List2 = res.data.data.creditCardSetting
                    this.List3 = res.data.data.buyerAddress
                    this.List4 = res.data.data.orderIPAddressSetting
                }else {
                    this.$message.error(res.data.data)
                }
            })
      },
      delSettings(item) {
        this.$confirm('确定要删除该项吗', '提示').then(() => {
            const API =  Baseurl + 'buyerAccountSettingController/deleteBuyerAccountSetting'
            const paramsData = {
                id: item.id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.selectSettings()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
            })
      },
      addList(val) {
          var params = {
              btnText: 1,
              disabled: false,
              cancel: 0
          }
          if(val === '1'){
            this.List.push(params)
          }else if(val === '2'){
            this.List2.push(params)
          }else if(val === '3'){
            this.List3.push(params)
          }else if(val === '4'){
            this.List4.push(params)
          }else {
              this.List5.push(params)
          }
      },
      cancel(val) {
          if(val === '1'){
            this.List.pop()
          }else if(val === '2'){
              this.List2.pop()
          }else if(val === '3'){
              this.List3.pop()
          }else if(val === '4'){
              this.List4.pop()
          }else{
              this.List5.pop()
          }
      },
      save1(item) {
          if(item.btnText === 1){
            if(item.programName === undefined) {
                this.$message('方案名称不能为空')
                return
            }
            const API =  Baseurl + 'buyerAccountCombinationController/insertBuyerAccountCombination'
            const paramsData = {
                programName: item.programName,                                  // 方案名称
                buyerAccountRankId: item.buyerAccountRankId,                                     // 买家账号等级id
                creditCardRankId: item.creditCardRankId,                              // 信用卡账号等级id
                buyerAddressRankId: item.buyerAddressRankId,                              // 买家地址等级id
                orderIPAddressRankId: item.orderIPAddressRankId,                            // 订单IP地址等级id
                companyId: this.companyId                                           // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        item.btnText = 0
                        this.selectSettings1()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
          }else if(item.btnText === 0) {
              item.btnText = 1
          }
      },
      selectSettings1() {
        const API =  Baseurl + 'buyerAccountCombinationController/selectBuyerAccountCombinations'
        const paramsData = {      
            companyId: 1                                         // 公司id
        }
        ajaxPost(API,paramsData)
            .then((res) => {
                if( res.data.code === 200 ) {
                    this.List5 = res.data.data
                }else {
                    this.$message.error(res.data.data)
                }
            })
      },
      delSettings1(item) {
        this.$confirm('确定要删除该项吗', '提示').then(() => {
            const API =  Baseurl + 'buyerAccountCombinationController/deleteBuyerAccountCombination'
            const paramsData = {
                id: item.id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.selectSettings1()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
            })
      },
      edit1(item) {
          this.dialogVisible1 = true
          this.id1 = item.id
          this.programName = item.programName
          this.buyerAccountRankId = item.buyerAccountRankId
          this.creditCardRankId = item.creditCardRankId
          this.buyerAddressRankId = item.buyerAddressRankId
          this.orderIPAddressRankId = item.orderIPAddressRankId
      },
      editDiallog1() {
            const API =  Baseurl + 'buyerAccountCombinationController/updateBuyerAccountCombination'
            const paramsData = {
                id: this.id1,
                programName: this.programName,                                  // 方案名称
                buyerAccountRankId: this.buyerAccountRankId,                                     // 买家账号等级id
                creditCardRankId: this.creditCardRankId,                              // 信用卡账号等级id
                buyerAddressRankId: this.buyerAddressRankId,                              // 买家地址等级id
                orderIPAddressRankId: this.orderIPAddressRankId,                              // 订单IP地址等级id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.dialogVisible1 = false
                        this.selectSettings1()
                    }else {
                        this.$message.error(res.data.data)
                    }
                })
      },
  },
};
</script>
<style lang="scss" scoped>
.BuyerAccountParameterSettings {
  width: 98%;
  // background: #F7F7F7;
  padding-bottom: 72px;
  .summary_bag {
    width: 98%;
    margin: auto;
    .summary_complete_bag {
      overflow: hidden;
      .title{
          font-size: 16px;
      }
      .card{
          margin: 20px 0 40px 0;
        .bottom {
            margin-top: 13px;
            line-height: 12px;
        }

        // .button {
        //     float: right;
        // }

      }
      .span-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .el-icon-question {
          font-size: 14px;
        }
      }
    }
    .box{
        border-top: 1px solid #dddee0;
        padding: 30px 0;
    }
    .form{
        .el-input {
            width:200px
        }
        .el-textarea{
            width: 60%;
        }
    }
    .box:nth-child(1) {
        border: none;
        padding-top: 0px;
    }
    /deep/ .el-card__header{
          background: #dddee0;
          font-size: 16px;
          padding: 15px 10px;
      }
  }
}
</style>